/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import './App.css'
import Page from './app/dashboard/page'
import LoginPage from './app/login/LoginComp'
import { ThemeProvider } from "@/components/theme-provider"
import { ErrorBoundary } from "react-error-boundary";
import {
	useNavigate,
	createBrowserRouter,
	RouterProvider,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HospitalComp from './app/hospital/HospitalComp';
import { Toaster } from "@/components/ui/sonner"
import AdminLayout from './app/admin/AdminLayout';
import Overview from './app/admin/Overview';
import Findings from './app/admin/Findings';
import Radiologists from './app/admin/Radiologists';
import Account from './app/admin/Account';
import Monitoring from './app/admin/Monitoring';
// import { ErrorBoundary } from "react-error-boundary";

// function ErrorBoundaryComp() {
// 	const navigate = useNavigate();
// 	navigate(-1);
// 	// message.error("something went wrong");

// 	return <div />;
// }

function ErrorBoundaryComp() {
	const navigate = useNavigate();
	navigate(-1);
	// message.error("something went wrong");

	return <div />;
}

const logError = console.log;

const router = createBrowserRouter([
	{
		path: "/",
		element: <LoginPage />,
	},
	{
		path: "/dashboard",
		element: <Page />,
	},
	{
		path: "/hospital",
		element: <HospitalComp />,
	},
	{
		path: "/admin",
		element: <AdminLayout />,
		children: [
			{
				index: true,
				element: <Overview />,
			},
			{
				path: "overview",
				element: <Overview />,
			},
			{
					path: "uploads",
					element: <Monitoring />,
			},
			{
				path: "findings",
				element: <Findings />,
			},
			{
				path: "radiologists",
				element: <Radiologists />,
			},
			{
				path: "accounts",
				element: <Account />,
			},
		],
	},
	// {
	// 	path: "settings",
	// 	element: <SettingsComp />
	// },
	// {
	// 	path: "worklist",
	// 	element: <WorklistPage />,
	// },
	// {
	// 	path: "viewer/:id",
	// 	element: <ViewerComp />,
	// },
]);

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: Infinity,
		},
	},
});


function App() {


  return (
    // <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      
      
    // </ThemeProvider>
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      {/* <LoginPage /> */}
	  <Toaster />
      <QueryClientProvider client={queryClient}>
        
				<ErrorBoundary
					fallback={<ErrorBoundaryComp />}
					onError={logError}
				>
					<RouterProvider router={router} />
				</ErrorBoundary>
			</QueryClientProvider>
      
     
    </ThemeProvider>
  )
}

export default App
